/**
 * Service layer — Pre-Design Report (CT-020).
 * Calls api/predesign-report.js (native pdf-lib) with a Clerk token and returns an object URL
 * the caller opens. `working:true` = draft preview; `working:false` = issued copy (no draft stamp).
 */

async function render(projectId, working) {
  const headers = { 'Content-Type': 'application/json' }
  try { if (window.__clerkGetToken) { const t = await window.__clerkGetToken(); if (t) headers['Authorization'] = 'Bearer ' + t } }
  catch (_) { /* server rejects unauthenticated */ }
  const res = await fetch('/api/predesign-report', { method: 'POST', headers, body: JSON.stringify({ projectId, working }) })
  if (!res.ok) { const j = await res.json().catch(() => ({})); return { error: j.error || ('Report failed (' + res.status + ')') } }
  const blob = await res.blob()
  return { pdfUrl: URL.createObjectURL(blob) }
}

/** Working-draft preview (stamped "WORKING DRAFT — NOT ISSUED"). */
export function previewPreDesignReport(projectId) { return render(projectId, true) }

/** Issued copy (no draft stamp). Storage to Supabase is a follow-on (see docs/PARCEL_RESEARCH.md). */
export function generatePreDesignReport(projectId) { return render(projectId, false) }

/**
 * Freeze the issued report as the milestone's final pre-design PDF (server renders + stores it as a
 * milestone_documents row). Called when a Pre-design Research milestone is posted. → { ok, url } | { error }.
 */
export async function freezePreDesignReport(projectId, milestoneId) {
  const headers = { 'Content-Type': 'application/json' }
  try { if (window.__clerkGetToken) { const t = await window.__clerkGetToken(); if (t) headers['Authorization'] = 'Bearer ' + t } }
  catch (_) { /* server rejects unauthenticated */ }
  try {
    const res = await fetch('/api/predesign-report', { method: 'POST', headers, body: JSON.stringify({ projectId, milestoneId, freeze: true }) })
    return res.json().catch(() => ({ error: 'Bad response from the report service.' }))
  } catch (e) { return { error: (e && e.message) || 'Freeze request failed.' } }
}
